import { render, staticRenderFns } from "./KeyReader.vue?vue&type=template&id=0f299fa8&scoped=true&"
import script from "./KeyReader.vue?vue&type=script&lang=js&"
export * from "./KeyReader.vue?vue&type=script&lang=js&"
import style0 from "./KeyReader.vue?vue&type=style&index=0&id=0f299fa8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f299fa8",
  null
  
)

export default component.exports